import Breadcrumb from '@/components/base/Breadcrumb';
import ContactForm from './components/ContactForm';

const contactItems = [
  {
    icon: 'ri-mail-send-line',
    label: '内容与投稿',
    value: 'hello@juhuidemudi.example.com',
    desc: '影评投稿、内容纠错与合作交流',
  },
  {
    icon: 'ri-question-answer-line',
    label: '意见反馈',
    value: 'feedback@juhuidemudi.example.com',
    desc: '站点建议、功能反馈与体验问题',
  },
  {
    icon: 'ri-shield-star-line',
    label: '版权与法务',
    value: 'legal@juhuidemudi.example.com',
    desc: '版权说明、内容授权等相关事宜',
  },
];

export default function Contact() {
  return (
    <div className="w-full">
      <section className="bg-primary-950 text-background-50">
        <div className="max-w-content mx-auto px-4 md:px-6 py-10 md:py-16">
          <Breadcrumb
            className="mb-5 [&_a]:text-background-200/80 [&_a:hover]:text-accent-400 [&_span]:text-background-50"
            items={[{ label: '首页', to: '/' }, { label: '联系我们' }]}
          />
          <h1 className="text-2xl md:text-4xl font-bold">联系我们</h1>
          <p className="mt-4 max-w-2xl text-sm md:text-base text-background-200/85 leading-relaxed">
            无论是对某部电影的解读有不同看法，还是想投稿一篇影评，亦或是发现了内容上的疏漏，
            都欢迎通过下面的方式联系我们。
          </p>
        </div>
      </section>

      <section className="max-w-content mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="w-1.5 h-7 rounded-full bg-accent-500"></span>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950">联系方式</h2>
            </div>

            <ul className="mt-6 space-y-4">
              {contactItems.map((c) => (
                <li
                  key={c.label}
                  className="flex items-start gap-4 p-5 rounded-lg bg-background-50 border border-background-200"
                >
                  <span className="w-11 h-11 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center shrink-0">
                    <i className={`${c.icon} text-xl`}></i>
                  </span>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-foreground-950">{c.label}</p>
                    <p className="mt-1 text-sm text-primary-600 break-all">{c.value}</p>
                    <p className="mt-1 text-xs text-foreground-400">{c.desc}</p>
                  </div>
                </li>
              ))}
            </ul>

            <div className="mt-6 p-5 rounded-lg bg-secondary-50 border border-secondary-200">
              <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
                <i className="ri-information-line text-secondary-600 w-4 h-4 flex items-center justify-center"></i>
                留言说明
              </h3>
              <ul className="mt-3 space-y-2 text-sm text-foreground-600 leading-relaxed">
                <li className="flex gap-2">
                  <span className="text-secondary-500">·</span>
                  带星号的姓名、邮箱与留言内容为必填项。
                </li>
                <li className="flex gap-2">
                  <span className="text-secondary-500">·</span>
                  留言内容请控制在 500 字以内，方便我们快速阅读。
                </li>
                <li className="flex gap-2">
                  <span className="text-secondary-500">·</span>
                  我们通常会在 1–2 个工作日内查看并回复。
                </li>
                <li className="flex gap-2">
                  <span className="text-secondary-500">·</span>
                  本站为演示站点，留言仅用于展示提交交互。
                </li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="flex items-center gap-3">
              <span className="w-1.5 h-7 rounded-full bg-primary-500"></span>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950">给我们留言</h2>
            </div>
            <p className="mt-2 text-sm text-foreground-500">
              填写下面的表单，把你的想法告诉我们。
            </p>
            <div className="mt-6">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}